import { AuditLog } from "./types";

const getAuditLogChangedBy = (auditLog: AuditLog, defaultTitle: string) => {
  // Merges are always performed by a center user; the actor's name is
  // captured directly as performed_by_name (merge_audit_logs.role means
  // something else entirely — see types.ts).
  if ("merge_type" in auditLog) {
    return auditLog.performed_by_name ?? defaultTitle;
  }

  let changedBy = defaultTitle;
  if (auditLog.role === "customer" && auditLog.customer) {
    changedBy = `${auditLog.customer.first_name} ${auditLog.customer.last_name}`;
  }
  if (auditLog.role === "center_user" && auditLog.center_user) {
    changedBy = `${auditLog.center_user.first_name} ${auditLog.center_user.last_name}`;
  }
  return changedBy;
};

export default getAuditLogChangedBy;
